<template>
  <v-dialog v-model="show" max-width="400" content-class="rounded-xl">
    <v-card>
      <v-card-title class="headline d-flex justify-center">
        Смена пароля
      </v-card-title>
      <v-card-text class="subtitle-1">
        На указанную почту было направлено письмо с инструкцией по смене пароля.
      </v-card-text>
      <v-card-actions>
        <v-btn color="green lighten-1" fab text @click.stop="show = false">
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      dialog: this.$store.getters.getConfirmDialog,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>